// Participant language helper: 'en' | 'es' | 'both'.
export function makeT(lang) {
  return (es, en) => (lang === "en" ? en : lang === "both" ? `${es}  ·  ${en}` : es);
}

// Three-way language selector used on participant surfaces.
export const LANGS = [
  { key: "es", label: "ES" },
  { key: "en", label: "EN" },
  { key: "both", label: "ES·EN" },
];
